import {
  GridItem,
  Card,
  CardBody,
  Heading,
  Image,
  Flex,
  Box,
  Text,
} from '@chakra-ui/react';
import { fadeInScaleAnimation } from '../../../resources/animations/animations';
import { useTranslation } from 'react-i18next';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { TrackerWrapper } from '@texas/components/shared/tracker/TrackerWrapper';
import { EntityType } from '@texas/api/endpoints/trackerApi';
import { clientEndpoints } from '@texas/clientEndpoints';
import { customerUserRoleLabel } from '@texas/utils/helpers/roleHelpers';

export interface BrandCardProps {
  name: string;
  id: number;
  nrOfArticles: number;
  logoIdentifier?: string | null;
  currentUserRoles: string[];
  currentUserCustomRoles: string[];
}

export function BrandCard(props: BrandCardProps) {
  const { t } = useTranslation();
  const roleLabel = customerUserRoleLabel(
    props.currentUserRoles,
    props.currentUserCustomRoles,
    t,
  );
  return (
    <GridItem>
      <TrackerWrapper entityId={props.id} entityType={EntityType.Customer}>
        <Card variant="brand" animation={fadeInScaleAnimation()}>
          <CardBody>
            <AngularNavLink
              display="flex"
              h="full"
              textDecoration="none"
              alignItems="center"
              to="customer"
              navobj={{ customerId: props.id }}
              gap={2}
            >
              {props.logoIdentifier && (
                <Box mb={1}>
                  <Image
                    src={clientEndpoints.previewImage(
                      props.logoIdentifier,
                      128,
                    )}
                    maxH="60px"
                    objectFit="contain"
                    borderRadius="md"
                    alt={props.name}
                  />
                </Box>
              )}
              <Flex flexDir="column" flexWrap="wrap">
                <Heading fontSize="lg">{props.name}</Heading>
                <Text fontSize="sm">
                  {props.nrOfArticles} {t('general.articles')}
                </Text>
                {roleLabel !== null && (
                  <Text
                    w="fit-content"
                    maxW="100%"
                    mt={1}
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="normal"
                    display="block"
                    fontSize="xs"
                    opacity={0.7}
                  >
                    {roleLabel}
                  </Text>
                )}
              </Flex>
            </AngularNavLink>
          </CardBody>
        </Card>
      </TrackerWrapper>
    </GridItem>
  );
}
